import { CONST } from '@common/constants/const.constant';
import { EPaymentMethod } from '@common/enums/payment-method.enum';
import { consoleService } from '@common/services/console.service';
import { IRegisterModel } from '@src/api/model/register.model';
import { useCallback } from 'react';

export interface IRegisterReturn {
    registerInfo: IRegisterModel;
    saveToRegister: (model: Partial<IRegisterModel>, callback?: (model: IRegisterModel) => void) => void;
    load: () => IRegisterModel;
}

const load = (): IRegisterModel => {
    const data = sessionStorage.getItem(CONST.sessionStorageKey_registration);
    if (data) {
        try {
            const res = JSON.parse(data);
            return {
                ...res,
                startDate: new Date(res.startDate),
            };
        } catch (ex) {
            consoleService.error(ex);
        }
    }

    return {
        card: undefined,

        paymentMethod: EPaymentMethod.card,
        isCheckPostCodeStepValid: false,
        isFirstBoxStepValid: false,
        isAccountDetailsStepValid: false,
        isDeliveryStepValid: false,
        isPreferencesStepValid: false,
        partialAddress: true,
        stripe_setup_indent_id: undefined,
        stripe_payment_method_id: undefined,
        refresh_token: undefined,
        app_client_id: '',
        landingUrl: '',

        terms: false,
        first_name: '',
        last_name: '',
        phone: '',
        safePlace: '',
        allergies: [],
        email: '',
        password: '',
        id_token: undefined,
        confirmPassword: '',
        marketingPreferences: false,
        shippingAddress: {
            postCode: '',
            label: '',
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            originalLabel: '',
            city: '',
            country: CONST.DEFAULT_COUNTRY_ABBR,
        },
        billingAddress: {
            postCode: '',
            label: '',
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            originalLabel: '',
            city: '',
            country: CONST.DEFAULT_COUNTRY_ABBR,
        },
        isBillingDifferent: false,

        priceId: '',
        price: 0,
        productId: '',
        quantity: 1,
        couponId: undefined,
        deliveryConfigId: undefined,
        startDate: undefined,
        deliveryDate: undefined,
    };
};

const saveToSessionStorage = ({ card, ...rest }: IRegisterModel): void => {
    sessionStorage.setItem(CONST.sessionStorageKey_registration, JSON.stringify(rest, null, 2));
};
const _globalRef: { current: IRegisterModel | undefined } = { current: undefined };
export const useRegister = (): IRegisterReturn => {
    if (!_globalRef.current) {
        _globalRef.current = load();
    }
    const saveToRegister = useCallback((data: Partial<IRegisterModel>, callback?: (model: IRegisterModel) => void): void => {
        if (!_globalRef.current) {
            _globalRef.current = load();
        }
        const newData: IRegisterModel = {
            ..._globalRef.current,
            ...data,
            shippingAddress: {
                ..._globalRef.current?.shippingAddress,
                ...(data.shippingAddress || {}),
            },
            billingAddress: {
                ..._globalRef.current?.billingAddress,
                ...(data.billingAddress || {}),
            },
        };
        _globalRef.current = newData;
        saveToSessionStorage(newData);
        callback && callback(newData);
    }, []);

    return {
        saveToRegister,
        registerInfo: _globalRef.current,
        load,
    };
};
